/**
 * HHT2 TimeLine Contents 정보
 * @type {string[]}
 */

export const HHT2_EP14_ANSWERS = [
    'The doorbell rings, and Harry opens the door.',
    'It’s pizza delivery! Matt has ordered BBQ Chicken pizza for lunch.',
    'Holly is very disappointed.',
    'Then, Holly remembers saying, “BBQ Chicken pizza is my favorite!”',
    'Holly and Harry are not happy. She asks Matt, “What’s for dinner, then?”',
    'Matt has ordered Hawaiian pizza for dinner!',
    'On the third day, Matt orders a veggie pizza for breakfast, and a pepperoni pizza for lunch.',
    'Finally, Stephanie comes home!',
    'Holly and Harry really missed Stephanie. Tony says, “I think they missed your food.”',
    'Stephanie is tired from the trip, so she promises to cook tomorrow.',
    'So, Stephanie ordered pizza! Holly and Harry scream, “Not again! No! No!”',
];

// export const HHT2_EP14_ANSWER_SOUNDS = [
//     '/HHT2_AB EP14_dyr01.mp3',
//     '/HHT2_AB EP14_dyr02.mp3',
//     '/HHT2_AB EP14_dyr03.mp3',
//     '/HHT2_AB EP14_dyr04.mp3',
//     '/HHT2_AB EP14_dyr05.mp3',
//     '/HHT2_AB EP14_dyr06.mp3',
//     '/HHT2_AB EP14_dyr07.mp3',
//     '/HHT2_AB EP14_dyr08.mp3',
//     '/HHT2_AB EP14_dyr09.mp3',
//     '/HHT2_AB EP14_dyr10.mp3',
//     '/HHT2_AB EP14_dyr11.mp3',
// ];

export const HHT2_EP14_ANSWER_SOUNDS = [
    '/6387a19539a0a095410b0f3c5551b942.mp3',
    '/5b0bff27f1962c57a3cc3771de651796.mp3',
    '/7dc3d5637a252e6d9840b5ef5089e5bb.mp3',
    '/274486499db3286dfe8ad951cf9f2dfc.mp3',
    '/7191caf5e9e2c03c4d7256ab368d233b.mp3',
    '/b0fbd35194f937afadf2082ccc38d961.mp3',
    '/dd4890d48c54a29e4c0bca2ae4dcd3c4.mp3',
    '/cc1816266d4de82b421ddb99caf737ad.mp3',
    '/d0a916d88d722dd90c2a0eac0ee000d1.mp3',
    '/b16082a117aa38cb60bf873e77912946.mp3',
    '/5351f076e91e4df6b0a6b203b0fa8284.mp3',
];


export const HHT2_EP14_QUIZ_ITEMS = [{
    'A': HHT2_EP14_ANSWERS[1],
    'B': HHT2_EP14_ANSWERS[8],
    'SoundIndexA': 1,
    'SoundIndexB': 8,
    'answer': HHT2_EP14_ANSWERS[1],
    'sound': [2, 3],
    'exception': false,
},
    {
        'A': HHT2_EP14_ANSWERS[4],
        'B': HHT2_EP14_ANSWERS[10],
        'SoundIndexA': 4,
        'SoundIndexB': 10,
        'answer': HHT2_EP14_ANSWERS[4],
        'sound': [5, 6],
        'exception': false,
    },
    {
        'A': HHT2_EP14_ANSWERS[2],
        'B': HHT2_EP14_ANSWERS[7],
        'SoundIndexA': 2,
        'SoundIndexB': 7,
        'answer': HHT2_EP14_ANSWERS[7],
        'sound': [8],
        'exception': false,
    },
    {
        'A': HHT2_EP14_ANSWERS[9],
        'B': HHT2_EP14_ANSWERS[3],
        'SoundIndexA': 9,
        'SoundIndexB': 3,
        'answer': HHT2_EP14_ANSWERS[9],
        'sound': [10],
        'exception': false,
    },
]
